module.exports = __webpack_public_path__ + "static/media/down-arrow.0cdb62c4.svg";